module.exports = __webpack_public_path__ + "static/img/bk_lake.531d35e0.jpg";